import { Text, Timeline } from "@mantine/core"
import React from "react"
import { useTranslation } from "react-i18next"

export const OnboardingTimeline = ({ step, newUser }) => {
	const { t } = useTranslation()

	return (
		<Timeline
			color="dark"
			active={step}
			lineWidth={3}
			bulletSize={15}
			style={{ position: "fixed" }}
		>
			<Timeline.Item title={t("components.onboarding_timeline.sign_up")}>
				<Text color="dimmed" size="xs">
					{t(
						"components.onboarding_timeline.create_your_kopy_account",
					)}
				</Text>
			</Timeline.Item>

			{newUser ? (
				<Timeline.Item
					title={t(
						"components.onboarding_timeline.choose_subscription",
					)}
				>
					<Text color="dimmed" size="xs">
						{t(
							"components.onboarding_timeline.choose_the_best_plan_for_you",
						)}
					</Text>
				</Timeline.Item>
			) : (
				<Timeline.Item
					title={t("components.onboarding_timeline.add_your_store")}
				>
					<Text color="dimmed" size="xs">
						{t(
							"components.onboarding_timeline.enter_your_shop_domain_to_add_your_store",
						)}
					</Text>
				</Timeline.Item>
			)}

			{newUser ? (
				<Timeline.Item
					title={t("components.onboarding_timeline.add_your_store")}
				>
					<Text color="dimmed" size="xs">
						{t(
							"components.onboarding_timeline.enter_your_shop_domain_to_add_your_store",
						)}
					</Text>
				</Timeline.Item>
			) : (
				<Timeline.Item
					title={t(
						"components.onboarding_timeline.choose_subscription",
					)}
				>
					<Text color="dimmed" size="xs">
						{t(
							"components.onboarding_timeline.choose_the_best_plan_for_you",
						)}
					</Text>
				</Timeline.Item>
			)}

			<Timeline.Item
				title={t("components.onboarding_timeline.last_steps")}
			>
				<Text color="dimmed" size="xs">
					{t(
						"components.onboarding_timeline.finish_setting_up_your_store_and_start_using_kopy",
					)}
				</Text>
			</Timeline.Item>
		</Timeline>
	)
}
